import * as constants from './constants';

const clientsReducer = (state = constants.initialState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FIND_CLIENT:
    case constants.FIND_CLIENT_FAIL:
    case constants.FIND_CLIENT_SUCCESS:
    case constants.FETCH_CLIENT:
    case constants.FETCH_CLIENT_FAIL:
    case constants.FETCH_CLIENT_SUCCESS:
    case constants.CREATE_CLIENT:
    case constants.CREATE_CLIENT_FAIL:
    case constants.CREATE_CLIENT_SUCCESS:
    case constants.UPDATE_CLIENT:
    case constants.UPDATE_CLIENT_FAIL:
    case constants.UPDATE_CLIENT_SUCCESS:
    case constants.DELETE_CLIENT:
    case constants.DELETE_CLIENT_FAIL:
    case constants.DELETE_CLIENT_SUCCESS:
    case constants.FETCH_CLIENT_INSURANCE_LOSSES_SUCCESS:
    case constants.FETCH_CLIENT_INSURANCE_LOSSES_FAIL:
    case constants.FETCH_CLIENT_SERVICE_CARDS_SUCCESS:
    case constants.FETCH_CLIENT_SERVICE_CARDS_FAIL:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default clientsReducer;
